/**
 * Locale-aware date formatting helpers.
 *
 * Uses `Intl.DateTimeFormat` so month/day names follow the active UI language.
 */

const DEFAULT_LOCALE = 'en';

const toValidDate = (input) => {
  if (!input) return null;
  const d = input instanceof Date ? input : new Date(input);
  return Number.isNaN(d.getTime()) ? null : d;
};

const toFiniteNumber = (input) => {
  const value = Number.parseFloat(input);
  return Number.isFinite(value) ? value : null;
};

export const formatShortDate = (dateInput, locale = DEFAULT_LOCALE) => {
  const date = toValidDate(dateInput);
  if (!date) return '';

  const options = { month: 'short', day: 'numeric', year: 'numeric' };

  try {
    return new Intl.DateTimeFormat(locale || DEFAULT_LOCALE, options).format(date);
  } catch (e) {
    // In case an invalid/unsupported locale is provided.
    return new Intl.DateTimeFormat(DEFAULT_LOCALE, options).format(date);
  }
};

export const formatLocalizedDateTime = (dateInput, locale = DEFAULT_LOCALE) => {
  const date = toValidDate(dateInput);
  if (!date) return '';

  const options = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  };

  try {
    return new Intl.DateTimeFormat(locale || DEFAULT_LOCALE, options).format(date);
  } catch (e) {
    return new Intl.DateTimeFormat(DEFAULT_LOCALE, options).format(date);
  }
};

export const hasActivePercentageDiscount = (
  discountPercentage,
  discountExpiry,
  referenceDate = new Date()
) => {
  const percentage = toFiniteNumber(discountPercentage);
  if (percentage === null || percentage <= 0) {
    return false;
  }

  if (!discountExpiry) {
    return true;
  }

  const expiryDate = toValidDate(discountExpiry);
  const now = toValidDate(referenceDate) || new Date();

  if (!expiryDate) {
    return false;
  }

  return expiryDate.getTime() > now.getTime();
};


